import { signInWithEmailAndPassword, signOut, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './firebaseConfig';

export default class FirebaseAuth {
  static logInWithEmailAndPassword(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  static passwordReset(email) {
    return sendPasswordResetEmail(auth, email);
  }

  static logOut() {
    return signOut(auth);
  }
}
